export default "/_next/static/chunks/fonts/Funnel Display SemiBold-2642e4ded67439d58b3545982d44cc55.ttf";